import { render } from "./Busquedas.vue?vue&type=template&id=6d803342&scoped=true"
import script from "./Busquedas.vue?vue&type=script&lang=js"
export * from "./Busquedas.vue?vue&type=script&lang=js"

import "./Busquedas.vue?vue&type=style&index=0&id=6d803342&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d803342"

export default script